import {
    DefaultApeMaxSpeedKilometersPerHour,
    DefaultApeOvertimeMinutes,
    DefaultApeSearchTimeLimitSeconds,
    DefaultApeUseRijtijdenwet,
    DefaultApeWinchServiceTimeInMinutes
} from '@/constants/ape-planning-settings';

// De optimalisatie-instellingen waarmee een plan-run naar APE gaat. De servicetijden per auto staan hier
// bewust niet: die komen uit defaultPickUpTimeInMinutes / defaultDropOffTimeInMinutes op de
// organisatie-instellingen, zodat de planner ze op één plek invult.
export interface OrganizationApeSettings {
    useRijtijdenwet: boolean;
    searchTimeLimitSeconds: number;
    overtimeMinutes: number;
    winchServiceTimeInMinutes: number;
    maxSpeedKilometersPerHour: number;
}

export const DefaultOrganizationApeSettings = (): OrganizationApeSettings => {
    return {
        useRijtijdenwet: DefaultApeUseRijtijdenwet,
        searchTimeLimitSeconds: DefaultApeSearchTimeLimitSeconds,
        overtimeMinutes: DefaultApeOvertimeMinutes,
        winchServiceTimeInMinutes: DefaultApeWinchServiceTimeInMinutes,
        maxSpeedKilometersPerHour: DefaultApeMaxSpeedKilometersPerHour
    };
}
